import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage } from '../../../helpers';
import { Link } from 'react-router-dom';
import en from './locales/en.json';
import fr from './locales/fr.json';
import FacebookLogin from 'react-facebook-login';
import GoogleLogin from 'react-google-login';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class LoginForm extends Component {

    render() { 
        return ( 
            <div className="showtix-section">
                <div className="container">
                    {this.props.loggedOut &&
                        <React.Fragment>
                            <div className="row">
                                <div className="col-12 text-center">
                                    <h1>{strings.loggedOut}</h1>
                                </div>
                            </div>
                            <hr className="mt-4 mb-4" />
                        </React.Fragment>
                    }

                    <div className="row">
                        <div className="col-12 text-center">
                            <h1>{strings.title}</h1>                            
                            <p className="showtix-subtitle">{strings.loginSocial}</p>
                            <FacebookLogin
                                appId= {process.env.REACT_APP_FACEBOOK_APP_ID}
                                autoLoad={false}
                                fields="name,email"
                                callback={this.props.facebookCallback}
                                cssClass="facebook-login-button"
                                icon="fa-facebook"
                            />
                            <GoogleLogin
                                clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                                buttonText="Login"
                                onRequest={this.props.googleButtonOpacityToggle}
                                onSuccess={this.props.googleCallback}
                                onFailure={this.props.googleButtonOpacityToggle}
                                className={this.props.googleButtonFaded ? 'google-login-button faded' : 'google-login-button'}
                            >      
                                <span>
                                    <i className="fa fa-google"></i>
                                    {strings.loginGoogle}
                                </span>
                            </GoogleLogin>
                        </div>
                    </div>

                    <hr className="mt-4 mb-4" />
                    <div className="row">
                        <div className="col-12 text-center">
                            <p className="showtix-subtitle">{strings.loginRegular}</p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-md-3">
                        </div>

                        <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <label className="showtix-label" htmlFor="username">{strings.username}*</label>
                                <div className="showtix-form__input">
                                    <input className="showtix-input"
                                        type="text"
                                        object="user"
                                        id="username"
                                        name="username"
                                        value={this.props.login.user.username || ''}
                                        readOnly={this.props.params.username}
                                        validation="(^(?!\s*$).+)"
                                        onChange={this.props.handleChange}
                                        onBlur={this.props.validateRequiredField}
                                        required={!this.props.isDisabled}
                                        disabled={this.props.isDisabled}
                                        tabIndex="1"
                                    />
                                </div>
                                <div className=" showtix-note">
                                    <p><Link to="/forgot-username" tabIndex="4">{strings.forgotUsername}</Link></p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-3">
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-md-3">
                        </div>

                        <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <label className="showtix-label" htmlFor="password">{strings.password}*</label>
                                <div className="showtix-form__input">
                                    <input className="showtix-input" 
                                        type="password" 
                                        object="user" 
                                        id="password" 
                                        name="password" 
                                        value={this.props.login.user.password} 
                                        validation="(^(?!\s*$).+)" 
                                        onChange={this.props.handleChange} 
                                        onBlur={this.props.validateRequiredField}
                                        required={!this.props.isDisabled}
                                        disabled={this.props.isDisabled} 
                                        tabIndex="2"
                                    />
                                </div>
                                <div className=" showtix-note">
                                    <p><Link to="/forgot-password" tabIndex="5">{strings.forgotPassword}</Link></p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-3">
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 text-center">
                            <button
                                type="submit"
                                className="showtix-button showtix-background__primary-1"
                                onClick={this.props.loginUser}
                                disabled={!this.props.isReadyToSubmit}
                                tabIndex="3"
                            >
                                <span>{strings.login}</span>
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        )

    }
}

LoginForm.propTypes = {
    login: PropTypes.shape({
        user: PropTypes.shape({
            password: PropTypes.string
        })
    }),
    validation: PropTypes.shape({
        user: PropTypes.shape({
            password: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            })
        })
    }),
    googleButtonFaded: PropTypes.bool,
    isDisabled: PropTypes.bool,
    facebookCallback: PropTypes.func,
    googleCallback: PropTypes.func,
    googleButtonOpacityToggle: PropTypes.func,
    handleChange: PropTypes.func,
    validateRequiredField: PropTypes.func,
    loginUser: PropTypes.func
}

export default LoginForm;


// WEBPACK FOOTER //
// ./src/components/Login/LoginForm/LoginForm.js